import clsx from 'clsx';
import React from 'react';

import { BaseLinkButtonProps, BaseRealButtonProps } from '../../BaseButton/BaseButton';
import TextButton from '../../TextButton/TextButton';
import styles from './NavigationBarTextButton.module.scss';

/**
 * 내비게이션 바에 맞춰 스타일을 적용한 텍스트 버튼.
 */
const NavigationBarTextButton: React.FC<BaseRealButtonProps | BaseLinkButtonProps> = ({ className, ...props }) => (
  <TextButton.Secondary className={clsx(styles.button, className)} {...props} />
);

export default NavigationBarTextButton;
